import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import { PostEntity } from '../post/post.entity';
import { UserEntity } from "../user/user.entity";
@Entity('post_activity_Shared')

export class PostActivitySharedEntity {
   
  @PrimaryGeneratedColumn('increment',{name:'id'}) Id: number;   
  @Column({
    type: 'int',
    nullable: false,
    name: 'post_id',
  })
  postId: number;
  @Column({
    type:'int',
    nullable:true,
    name:'shared_by'
  })
  sharedBy: number;
  @Column({
    type:'int',
    nullable:true,
    name:'shared_with'
  })
  sharedWith: number;
 
 
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  @VersionColumn({
    default:1,
    name: "version_flag"
  })
  versionFlag: number;
      
  @ManyToOne(() => PostEntity, (post: PostEntity) => post.postactivityshared)
  @JoinColumn({ name:'post_id'})
  post: PostEntity;

  @ManyToOne(() => UserEntity, (sharedby: UserEntity) => sharedby.postactivitysharedby)
  @JoinColumn({name:'shared_by'})
  sharedby: UserEntity;
  @ManyToOne(() => UserEntity, (sharedwith: UserEntity) => sharedwith.postactivitysharedwith)
  @JoinColumn({name:'shared_with'})
  sharedwith: UserEntity;
      
}


